import React, { createContext, useContext, useState } from "react";
import axios from "axios";

export const SalesInvoiceContext = createContext();

export const useSalesInvoiceContext = () => useContext(SalesInvoiceContext);

export const SalesInvoiceProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [invoices, setInvoices] = useState([]);

  const createSalesInvoice = async (invoiceData) => {
    setLoading(true);
    setError(null);
    setSuccess(null);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/invoice/newSalesInvoice.php`,
        invoiceData,
        { withCredentials: true }
      );
      setSuccess(response.data.message || "تم إنشاء فاتورة البيع بنجاح");
      setLoading(false);
      return response.data;
    } catch (err) {
      setError(
        err.response?.data?.message || "حدث خطأ أثناء إنشاء فاتورة البيع"
      );
      setLoading(false);
      throw err;
    }
  };

  const getSalesInvoices = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/invoice/getSalesInvoices.php`,
        { withCredentials: true }
      );
      if (response.data.status === "success") {
        setInvoices(response.data.invoices);
      }
      setLoading(false);
      return response.data;
    } catch (err) {
      setError(err.response?.data?.message || "حدث خطأ أثناء جلب فواتير البيع");
      setLoading(false);
      throw err;
    }
  };

  const getSalesInvoice = async (id) => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/invoice/getSalesInvoice.php?id=${id}`,
        { withCredentials: true }
      );
      setLoading(false);
      return response.data;
    } catch (err) {
      setError(
        err.response?.data?.message || "حدث خطأ أثناء جلب تفاصيل الفاتورة"
      );
      setLoading(false);
      throw err;
    }
  };

  const cancelSalesInvoice = async (id) => {
    setLoading(true);
    setError(null);
    setSuccess(null);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/invoice/cancelSalesInvoice.php?id=${id}`,
        {},
        { withCredentials: true }
      );
      setSuccess(response.data.message || "تم إلغاء الفاتورة بنجاح");
      setLoading(false);
      return response.data;
    } catch (err) {
      setError(err.response?.data?.message || "حدث خطأ أثناء إلغاء الفاتورة");
      setLoading(false);
      throw err;
    }
  };

  return (
    <SalesInvoiceContext.Provider
      value={{
        loading,
        error,
        success,
        invoices,
        createSalesInvoice,
        getSalesInvoices,
        getSalesInvoice,
        cancelSalesInvoice,
      }}
    >
      {children}
    </SalesInvoiceContext.Provider>
  );
};
